// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file shop_config/types/v1/shipment.proto (package shop_config.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Money } from "../../../types/v1/money_pb.js";
import { Text } from "../../../types/v1/text_pb.js";

/**
 * @generated from enum shop_config.types.v1.ShipmentMethod
 */
export const ShipmentMethod = /*@__PURE__*/ proto3.makeEnum(
  "shop_config.types.v1.ShipmentMethod",
  [
    {no: 0, name: "SHIPMENT_METHOD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SHIPMENT_METHOD_POSTAL", localName: "POSTAL"},
    {no: 2, name: "SHIPMENT_METHOD_COLLECT", localName: "COLLECT"},
    {no: 3, name: "SHIPMENT_METHOD_EMAIL", localName: "EMAIL"},
    {no: 4, name: "SHIPMENT_METHOD_ON_SITE_PRINT", localName: "ON_SITE_PRINT"},
  ],
);

/**
 * @generated from message shop_config.types.v1.ShipmentFee
 */
export const ShipmentFee = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.ShipmentFee",
  () => [
    { no: 1, name: "method", kind: "enum", T: proto3.getEnumType(ShipmentMethod) },
    { no: 2, name: "price", kind: "message", T: Money },
  ],
);

/**
 * @generated from message shop_config.types.v1.ShipmentConfiguration
 */
export const ShipmentConfiguration = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.ShipmentConfiguration",
  () => [
    { no: 1, name: "methods", kind: "enum", T: proto3.getEnumType(ShipmentMethod), repeated: true },
    { no: 2, name: "information_text", kind: "message", T: Text, opt: true },
    { no: 3, name: "fees", kind: "message", T: ShipmentFee, repeated: true },
  ],
);

/**
 * @generated from message shop_config.types.v1.SaveShipmentConfigurationRequest
 */
export const SaveShipmentConfigurationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.SaveShipmentConfigurationRequest",
  () => [
    { no: 1, name: "configuration", kind: "message", T: ShipmentConfiguration },
  ],
);

/**
 * @generated from message shop_config.types.v1.SaveShipmentConfigurationResponse
 */
export const SaveShipmentConfigurationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.SaveShipmentConfigurationResponse",
  () => [
    { no: 1, name: "configuration", kind: "message", T: ShipmentConfiguration },
  ],
);

/**
 * @generated from message shop_config.types.v1.GetShipmentConfigurationRequest
 */
export const GetShipmentConfigurationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.GetShipmentConfigurationRequest",
  [],
);

/**
 * @generated from message shop_config.types.v1.GetShipmentConfigurationResponse
 */
export const GetShipmentConfigurationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "shop_config.types.v1.GetShipmentConfigurationResponse",
  () => [
    { no: 1, name: "configuration", kind: "message", T: ShipmentConfiguration },
  ],
);

